import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { CopyToClipboardButton, copyToClipboardGroupKey } from '../buttons/copyToClipboardButton';
export const CellActionsWrapper = t0 => {
  const $ = _c(6);
  const {
    textToCopy,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundImage: "linear-gradient(90deg, transparent 0%, var(--cell-bg-color, var(--mui-palette-background-default)) 28%)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== textToCopy) {
    t2 = <Box paddingLeft="16px" className="opacity-0 group-hover/copy:opacity-100 hover:opacity-100 transition-opacity" sx={t1} position="absolute" right="0" top="0"><Stack direction="row" alignItems="center"><CopyToClipboardButton textToCopy={textToCopy} size="small" showOnlyOnHover={true} /></Stack></Box>;
    $[1] = textToCopy;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <Box className={copyToClipboardGroupKey} position="relative">{children}{t2}</Box>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};